import { Box } from '@mui/material';

export const TitleTable = ({ title }) => {
    return (
        <Box>
            <label
                style={{
                    fontFamily: 'Montserrat',
                    fontStyle: 'normal',
                    fontWeight: 'bold',
                    fontSize: '18px',
                    lineHeight: '22px',
                    color: '#182D55'
                }}>
                {title}
            </label>
        </Box>
    );
};
